import { render } from "./ResourceDownload.vue?vue&type=template&id=05cb78ee&scoped=true"
import script from "./ResourceDownload.vue?vue&type=script&lang=js"
export * from "./ResourceDownload.vue?vue&type=script&lang=js"

import "./ResourceDownload.vue?vue&type=style&index=0&id=05cb78ee&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ResourceDownload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cb78ee"]])

export default __exports__